// Banner giải thưởng (thay dòng thông báo cập nhật nội dung cũ).
const NewsTicker = () => {
    return (
        <div className="bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-white border-b border-amber-600 min-h-10 w-full z-50 flex items-center justify-center px-4 py-1.5">
            <div className="font-bold text-center text-sm md:text-base ticker-pulse">
                🏆 Giải Nhất — Giải thưởng tiên phong ứng dụng AI trong giáo dục Việt Nam 2025 · Trải nghiệm Soạn bài giảng AI & Khoá học tương tác phiên bản nâng cấp đặc biệt!
            </div>
            <style>{`
                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.85;
                    }
                }

                .ticker-pulse {
                    animation: pulse 2.5s ease-in-out infinite;
                }

                .ticker-pulse:hover {
                    animation-play-state: paused;
                }
            `}</style>
        </div>
    );
};

export default NewsTicker;
